import { createElementBlock as l, openBlock as t, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(i, o) {
  return t(), l("svg", n, o[0] || (o[0] = [
    e("path", {
      fill: "url(#ic_loading_web_svg__a)",
      "fill-rule": "evenodd",
      d: "M10.812 2.075c5.496-.672 10.505 3.222 11.18 8.706a1 1 0 1 1-1.985.245c-.54-4.382-4.545-7.504-8.952-6.965S3.52 8.593 4.06 12.975s4.545 7.504 8.953 6.964a1 1 0 1 1 .242 1.986c-5.496.672-10.504-3.222-11.18-8.706C1.4 7.734 5.315 2.748 10.812 2.075",
      "clip-rule": "evenodd"
    }, null, -1),
    e("defs", null, [
      e("linearGradient", {
        id: "ic_loading_web_svg__a",
        x1: "14.291",
        x2: "21.025",
        y1: "20.998",
        y2: "7.03",
        gradientUnits: "userSpaceOnUse"
      }, [
        e("stop", {
          "stop-color": "#1E0046",
          "stop-opacity": "0"
        }),
        e("stop", {
          offset: "1",
          "stop-color": "#1E0046"
        })
      ])
    ], -1)
  ]));
}
const c = { render: r };
export {
  c as default,
  r as render
};
//# sourceMappingURL=ic_loading_web-DHJI7k90.js.map
